import { render } from "./RuangKosong.vue?vue&type=template&id=70113710"
import script from "./RuangKosong.vue?vue&type=script&lang=js"
export * from "./RuangKosong.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__